/*================ Shopify Common JS ================*/
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

/*================ Preorder / Stoq helpers (ported from US theme) ================*/
/** Locale-aware cart endpoint (EU markets/languages prefix routes, e.g. /de/cart.js). */
function preorderCartUrl(path) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root + path;
}

/** True only when the main PDP ATC is genuinely unavailable — not while add-to-cart is in flight. */
function isMainAtcOutOfStock(atcBtn) {
  if (!atcBtn) return false;
  if (atcBtn.classList.contains('loading')) return false;
  return !!atcBtn.disabled;
}
window.isMainAtcOutOfStock = isMainAtcOutOfStock;

/** Stoq selling plan (from the app's inline config) covering the given variant. Null when the variant isn't on a Stoq preorder. */
function getStoqSellingPlanFor(variantId) {
  var appCfg = window._RestockRocketConfig;
  if (variantId == null || !appCfg || !Array.isArray(appCfg.sellingPlans)) return null;
  return appCfg.sellingPlans.filter(function (plan) {
    return plan.enabled && Array.isArray(plan.variant_ids) && plan.variant_ids.some(function (id) {
      return String(id) === String(variantId);
    });
  })[0] || null;
}
window.getStoqSellingPlanFor = getStoqSellingPlanFor;

/** Stoq's per-variant shipping estimate text (e.g. "ETA Mid Oct"), or ''. */
function getStoqShippingTextFor(variantId) {
  var appCfg = window._RestockRocketConfig;
  var texts = appCfg && appCfg.cachedVariantShippingTexts && appCfg.cachedVariantShippingTexts.variant_shipping_texts;
  return (texts && texts[variantId]) || '';
}
window.getStoqShippingTextFor = getStoqShippingTextFor;

/**
 * Line-item properties Stoq's own PDP add would attach to this variant's
 * preorder line — most importantly the visible cart text (e.g.
 * "Preorder: ETA End of Sept"). Programmatic /cart/add.js calls must merge
 * these in: selling_plan alone creates the preorder line, but without the
 * app's cart texts. Uses the app's public _RestockRocket.getLineItemProperties
 * when loaded; otherwise rebuilds the shipping-text property from
 * _RestockRocketConfig's cached per-variant texts. {} when not on preorder.
 */
function getStoqPreorderLineProperties(variantId) {
  try {
    var plan = getStoqSellingPlanFor(variantId);
    if (!plan) return {};

    var rr = window._RestockRocket;
    if (rr && typeof rr.getLineItemProperties === 'function') {
      var props = rr.getLineItemProperties(plan, variantId) || {};
      var filtered = {};
      Object.keys(props).forEach(function (key) {
        // "attributes[...]" entries are cart attributes, not line properties.
        if (key.indexOf('attributes[') !== 0) filtered[key] = props[key];
      });
      return filtered;
    }

    var out = {};
    var text = getStoqShippingTextFor(variantId);
    if (plan.shipping_line_item_property_enabled && text) {
      // Mirror the app's format: "Key: value" splits into a named property,
      // plain text lands under the selling plan's name.
      if (text.indexOf(':') !== -1) {
        var parts = text.split(':');
        out[parts.shift()] = parts.join(':').trim();
      } else {
        out[plan.name] = text;
      }
    }
    return out;
  } catch (e) {
    return {};
  }
}
window.getStoqPreorderLineProperties = getStoqPreorderLineProperties;

/** Companion-specific wrapper kept for existing call sites. */
function getPreorderCompanionProperties(variantId) {
  return getStoqPreorderLineProperties(variantId);
}
window.getPreorderCompanionProperties = getPreorderCompanionProperties;

/**
 * Fills the pro-package / upsell "[data-preorder-shipping-for]" placeholders
 * (component-pro-package.liquid) with Stoq's shipping estimate when the
 * offered variant is on preorder. Leaves them hidden otherwise.
 */
function renderStoqPreorderShippingNotes() {
  document.querySelectorAll('[data-preorder-shipping-for]').forEach(function (el) {
    var variantId = el.getAttribute('data-preorder-shipping-for');
    if (!getStoqSellingPlanFor(variantId)) return;
    var text = getStoqShippingTextFor(variantId);
    if (!text) return;
    el.textContent = 'Estimated Shipping: ' + text;
    el.hidden = false;
  });
}
window.renderStoqPreorderShippingNotes = renderStoqPreorderShippingNotes;

/**
 * Theme-owned "Preorder" pill after the PDP price (text from Theme settings >
 * Preorder Access Gate > Preorder badge; the matching CSS in
 * preorder-access-gate.liquid also hides Stoq's own price badge so only one
 * shows). Injected into every PDP price container (mobile + desktop) when the
 * selected variant is on a Stoq preorder, removed when it isn't. The CRO
 * sticky bar clones the price innerHTML, so it inherits the badge for free.
 */
function renderThemePreorderBadge() {
  var cfg = window.preorderGateConfig;
  if (!cfg || !cfg.badgeText) return;

  var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
  var variantInput = mainForm && mainForm.querySelector('input[name="id"]');
  if (!variantInput) return;

  var isPreorder = !!getStoqSellingPlanFor(variantInput.value);
  var containers = [
    '.stroller-main-product__price',
    '.product__mobile-header-price .product__price',
    '.reviews__price .product__price',
    '.product__price'
  ];
  document.querySelectorAll(containers.join(', ')).forEach(function (priceEl) {
    // The sticky bar's cloned price is managed via innerHTML sync, not here.
    if (priceEl.closest('.cro-pdp-sticky-bar__price')) return;
    var badge = priceEl.querySelector('.theme-preorder-badge');
    if (isPreorder && !badge) {
      badge = document.createElement('span');
      badge.className = 'theme-preorder-badge';
      badge.textContent = cfg.badgeText;
      priceEl.appendChild(badge);
    } else if (!isPreorder && badge) {
      badge.remove();
    }
  });
}
window.renderThemePreorderBadge = renderThemePreorderBadge;

// Re-render on variant switches: preorder is per-variant and the theme's
// price scripts rewrite the price markup (wiping the badge). Delayed a tick
// so it runs after the price update.
document.addEventListener('variant:change', function () {
  setTimeout(renderThemePreorderBadge, 0);
});

/**
 * Adds the preorder-gate companion product when the given variant belongs to
 * a gated preorder product — used by add paths outside the gated PDP form
 * (e.g. the cart drawer's assisted-wheels toggle). Skips the add when a
 * companion line parented to this variant is already in the cart, so
 * repeated toggles can't duplicate it. Config: window.preorderGateConfig
 * (preorder-access-gate.liquid).
 */
function maybeAddPreorderCompanion(variantId, quantity) {
  var cfg = window.preorderGateConfig;
  if (!cfg || !cfg.companionVariantId || !Array.isArray(cfg.gatedVariantIds)) return Promise.resolve(false);
  if (cfg.gatedVariantIds.indexOf(String(variantId)) === -1) return Promise.resolve(false);

  return fetch(preorderCartUrl('cart.js'))
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var exists = cart.items.some(function (item) {
        return item.properties && item.properties._free_gift === 'true' &&
          String(item.properties._parent_variant_id) === String(variantId);
      });
      if (exists) return false;
      var companionItem = {
        id: cfg.companionVariantId,
        quantity: quantity || 1,
        properties: { _free_gift: 'true', _parent_variant_id: String(variantId) }
      };
      // Companion on Stoq preorder: attach its selling plan so the line is
      // added in its preorder state, not as a plain default variant, plus
      // the app's line properties (visible shipping text in the cart).
      if (cfg.companionSellingPlanId) {
        companionItem.selling_plan = cfg.companionSellingPlanId;
        Object.assign(companionItem.properties, getPreorderCompanionProperties(cfg.companionVariantId));
      }
      return fetch(preorderCartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [companionItem] })
      }).then(function (res) { return res.ok; });
    })
    .catch(function () { return false; });
}
window.maybeAddPreorderCompanion = maybeAddPreorderCompanion;

/** Removes companion (_free_gift) lines parented to the given variant — the counterpart of maybeAddPreorderCompanion for remove/toggle-off flows. */
function removePreorderCompanionFor(variantId) {
  var cfg = window.preorderGateConfig;
  if (!cfg || !cfg.companionVariantId) return Promise.resolve();

  return fetch(preorderCartUrl('cart.js'))
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var keys = [];
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._free_gift === 'true' &&
            String(item.properties._parent_variant_id) === String(variantId)) {
          keys.push(item.key);
        }
      });
      // Keys, not 1-based indexes: /cart/change.js reorders the cart, and a
      // parent can have more than one _free_gift line (main companion +
      // metafield e-wheels upsell on gated PDPs).
      return keys.reduce(function (chain, key) {
        return chain.then(function () {
          return fetch(preorderCartUrl('cart/change.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        });
      }, Promise.resolve());
    })
    .catch(function () {});
}
window.removePreorderCompanionFor = removePreorderCompanionFor;

/** Customizer per-cart quantity limit for gated/companion variants (Theme settings > Preorder Access Gate > Quantity limits). Null when unlimited. */
function getThemePreorderMaxQty(variantId) {
  var cfg = window.preorderGateConfig;
  var map = cfg && cfg.variantMaxQuantities;
  if (!map || variantId == null) return null;
  var limit = parseInt(map[String(variantId)], 10);
  return isNaN(limit) || limit <= 0 ? null : limit;
}
window.getThemePreorderMaxQty = getThemePreorderMaxQty;

/**
 * Effective per-variant quantity cap: the LOWER of the Stoq app's preorder
 * limit (_StoqConfig.variantsPreorderMaxCount) and the customizer limit
 * (preorderGateConfig.variantMaxQuantities). Every add / quantity-change /
 * button-state path consults this one function. Null when uncapped.
 */
function getStoqPreorderLimit(variantId) {
  var stoqLimit = null;
  var counts = window._StoqConfig && window._StoqConfig.variantsPreorderMaxCount;
  if (counts && variantId != null) {
    var limit = parseInt(counts[variantId], 10);
    stoqLimit = isNaN(limit) || limit <= 0 ? null : limit;
  }
  var themeLimit = getThemePreorderMaxQty(variantId);
  if (stoqLimit != null && themeLimit != null) return Math.min(stoqLimit, themeLimit);
  return stoqLimit != null ? stoqLimit : themeLimit;
}
window.getStoqPreorderLimit = getStoqPreorderLimit;

/**
 * Stoq only flips a capped preorder ATC to "Out of Stock" on page reload.
 * Called after any AJAX cart change: compares the current PDP variant's cart
 * quantity against the app's cap and applies (or undoes) the same
 * disabled-in-place state in real time. The CRO sticky bar mirrors it via its
 * main-button MutationObserver. Pass a /cart.js-shaped state to skip a fetch.
 */
function syncStoqPreorderCapState(cart) {
  var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
  var atcBtn = mainForm && mainForm.querySelector('button[type="submit"]');
  var variantInput = mainForm && mainForm.querySelector('input[name="id"]');
  var variantId = variantInput && variantInput.value;
  if (!atcBtn || !variantId) return;

  var limit = getStoqPreorderLimit(variantId);
  if (!limit) return;

  var apply = function (state) {
    var item = (state.items || []).find(function (i) {
      return String(i.variant_id) === String(variantId);
    });
    var capped = (item ? item.quantity : 0) >= limit;
    var span = atcBtn.querySelector('span');

    if (capped && !atcBtn.dataset.stoqCapApplied) {
      atcBtn.dataset.stoqCapApplied = 'true';
      if (span) {
        atcBtn.dataset.stoqCapPrevLabel = span.textContent;
        span.textContent = 'Out of Stock';
      }
      atcBtn.disabled = true;
      // Grey out the CTA at the cap ('important' beats Stoq's inline styles)
      atcBtn.style.setProperty('background-color', '#CBCBCB', 'important');
    } else if (!capped && atcBtn.dataset.stoqCapApplied) {
      delete atcBtn.dataset.stoqCapApplied;
      atcBtn.disabled = false;
      if (span && atcBtn.dataset.stoqCapPrevLabel != null) span.textContent = atcBtn.dataset.stoqCapPrevLabel;
      delete atcBtn.dataset.stoqCapPrevLabel;
      atcBtn.style.removeProperty('background-color');
    }

    // Keep the app's injected preorder description box in step with the cap
    document.querySelectorAll('.restock-rocket-preorder-description').forEach(function (el) {
      el.style.display = capped ? 'none' : '';
    });

    // Customizer "limit reached" message below the Out of Stock button.
    // cappedMessage is only rendered on gated product pages (null elsewhere).
    var gateCfg = window.preorderGateConfig;
    if (gateCfg && gateCfg.cappedMessage) {
      var msgEl = document.getElementById('preorder-cap-message');
      if (capped && !msgEl && atcBtn.parentNode) {
        msgEl = document.createElement('p');
        msgEl.id = 'preorder-cap-message';
        msgEl.className = 'preorder-cap-message';
        msgEl.textContent = gateCfg.cappedMessage;
        atcBtn.insertAdjacentElement('afterend', msgEl);
      }
      if (msgEl) msgEl.style.display = capped ? '' : 'none';
    }

    // The cap state lands asynchronously (after a /cart.js fetch), often
    // after other UIs (e.g. the CRO sticky bar) already re-synced from the
    // main button — let them re-sync once the state is actually applied.
    document.dispatchEvent(new CustomEvent('preorder:cap-synced', { detail: { capped: capped } }));
  };

  if (cart && cart.items) {
    apply(cart);
  } else {
    fetch(preorderCartUrl('cart.js'))
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }
}
window.syncStoqPreorderCapState = syncStoqPreorderCapState;

// With the cap now enforced by the theme, make sure a cart that is already at
// the cap disables the PDP ATC on page load too. _StoqConfig can be injected
// after window load, so re-check once shortly after.
window.addEventListener('load', function () {
  syncStoqPreorderCapState();
  setTimeout(syncStoqPreorderCapState, 3000);
  // Stoq's config is injected inline but can also arrive late — retry once.
  renderStoqPreorderShippingNotes();
  setTimeout(renderStoqPreorderShippingNotes, 3000);
  renderThemePreorderBadge();
  setTimeout(renderThemePreorderBadge, 3000);
});

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.formatMoney = function (cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

/*================ Helper Functions ================*/
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function getCookie(name) {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function slideUp(target, duration = 500) {
  if (target) {
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.display = "none";
      target.style.removeProperty("height");
      target.style.removeProperty("padding-top");
      target.style.removeProperty("padding-bottom");
      target.style.removeProperty("margin-top");
      target.style.removeProperty("margin-bottom");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
      //alert("!");
    }, duration);
  }
}

function slideDown(target, duration = 500) {
  if (target) {
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;
    if (display === "none") display = "block";
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
    }, duration);
  }
}

function slideToggle(target, duration = 500) {
  if (window.getComputedStyle(target).display === "none") {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

function fadeIn(target, duration = 500, display = "block") {
  target.style.opacity = 0;
  target.style.display = display;
  var last = +new Date();
  var tick = function () {
    target.style.opacity =
      +target.style.opacity + (new Date() - last) / duration;
    last = +new Date();
    if (+target.style.opacity < 1) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) ||
        setTimeout(tick, 16);
    } else {
    }
  };
  tick();
}

function fadeOut(target, duration = 500) {
  target.style.display = "";
  target.style.opacity = 1;
  let last = +new Date();
  let tick = function () {
    target.style.opacity = Number(
      +target.style.opacity - (new Date() - last) / duration
    ).toFixed(4);
    last = +new Date();
    if (-target.style.opacity <= 0) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) ||
        setTimeout(tick, 16);
    } else {
      target.style.opacity = 0;
    }
  };
  tick();
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}

function atcGetSectionsToRender() {
  const cartDrawerContent = document.getElementById("cart-drawer__content");
  const mainCartItems = document.getElementById("main-cart-items");
  const mainCartSummary = document.getElementById("main-cart-total-summary");
  const cartWrapper = document.getElementById("cart-wrapper");
  
  const sections = [
    {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section",
    },
  ];
  
  if (cartDrawerContent && cartDrawerContent.dataset.id) {
    sections.unshift({
      id: "cart-drawer__content",
      section: cartDrawerContent.dataset.id,
      selector: ".cart-drawer__content",
    });
  }
  
  if (mainCartItems && mainCartItems.dataset.id) {
    sections.push({
      id: "main-cart-items",
      section: mainCartItems.dataset.id,
      selector: ".cart__items",
    });
  }
  
  if (cartWrapper && cartWrapper.dataset.id) {
    sections.push({
      id: "cart-wrapper",
      section: cartWrapper.dataset.id,
      selector: "cart-items",
    });
  }
  
  if (mainCartSummary && mainCartSummary.dataset.id) {
    sections.push({
      id: "main-cart-total-summary", 
      section: mainCartSummary.dataset.id,
      selector: ".cart__summary",
    });
  }
  
  return sections;
}

const atcButtons = document.querySelectorAll(".js-add-to-cart");
document.body.addEventListener("click", (event) => {
  const closest = event.target.closest(".js-add-to-cart");

  if (event.target.classList.contains("js-add-to-cart") || closest) {
    event.stopPropagation();
    event.preventDefault();
    const button = event.target.classList.contains("js-add-to-cart") ? event.target : closest;

    // Preorder access gate: locked visitors cannot add a gated product from
    // product-card quick view. The gate snippet's capture listener should
    // already have stopped this; this is defense in depth.
    if (
      (button.classList.contains("quick-view-content__add-to-cart--preorder-gated") ||
        button.classList.contains("quick-view-modal__add-to-cart--preorder-gated")) &&
      !document.documentElement.classList.contains("preorder-access-unlocked")
    ) {
      return;
    }
    const id = Number(button.dataset.id);
    const freeGiftId = button.dataset.freeGift;
    let properties = null,
      dataProperties = button.dataset.properties || null;

    if (dataProperties != null) properties = JSON.parse(dataProperties);

    const body = JSON.stringify({
      items: [
        {
          id: id,
          quantity: 1,
          properties: properties,
        },
      ],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((parsedState) => {
        const addedItem = parsedState.items ? parsedState.items[parsedState.items.length - 1] : parsedState;
        
        if (freeGiftId && freeGiftId !== '' && addedItem && addedItem.variant_id) {
          const freeGiftPayload = {
            id: freeGiftId,
            quantity: 1,
            properties: {
              _free_gift: 'true',
              _parent_variant_id: String(addedItem.variant_id)
            }
          };
          // Companion on Stoq preorder: attach its selling plan so the line
          // is added in its preorder state, not as a plain default variant,
          // plus the app's line properties (visible shipping text in cart).
          const gateCfg = window.preorderGateConfig;
          if (gateCfg && gateCfg.companionSellingPlanId &&
              String(gateCfg.companionVariantId) === String(freeGiftId)) {
            freeGiftPayload.selling_plan = gateCfg.companionSellingPlanId;
            Object.assign(freeGiftPayload.properties, getPreorderCompanionProperties(freeGiftId));
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(freeGiftPayload)
          })
          .then(res => res.json())
          .then(() => {
            return fetch(`${routes.cart_update_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                updates: {},
                sections: atcGetSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              })
            }).then(response => response.json());
          });
        }
        return parsedState;
      })
      .then((parsedState) => {
        atcGetSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector("cart-drawer").open();
      });
  }
});

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

/*================ Animations ================*/
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);

// Fade In Up
const fadeInUpElems = gsap.utils.toArray(".fade-in-up");
fadeInUpElems.forEach((elem) => {
  const duration = Number(elem.dataset.duration);
  const delay = Number(elem.dataset.delay);

  gsap.to(elem, {
    opacity: 1,
    y: 0,
    duration: duration || 1,
    delay: delay || 0,
    ease: "power2",
    scrollTrigger: {
      trigger: elem,
      start: "top 80%",
    },
  });
});

/*================ Components ================*/
var MenuDrawer = class extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.drawer = document.getElementById("menu-drawer");
    this.openButtons = document.querySelectorAll(".js-open-menu");
    this.closeButtons = document.querySelectorAll(".js-close-menu");
    this.pageOverlayElement = document.querySelector(".page-overlay");
    this.menuButtons = document.querySelectorAll(
      ".menu-drawer__menu-item.menu-button"
    );
    this.backButtons = document.querySelectorAll(".menu-drawer__menu-header");

    this.drawer.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.closeMenuDrawer()
    );
    this.bindEvents();
  }

  bindEvents() {
    this.openButtons.forEach((openBtn) =>
      openBtn.addEventListener("click", this.openMenuDrawer.bind(this))
    );
    this.closeButtons.forEach((closeBtn) =>
      closeBtn.addEventListener("click", this.closeMenuDrawer.bind(this))
    );
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.menuButtons.forEach((menuBtn) =>
      menuBtn.addEventListener("click", this.handleMenuClick.bind(this))
    );
    this.backButtons.forEach((backBtn) =>
      backBtn.addEventListener("click", this.handleBackClick.bind(this))
    );
  }

  openMenuDrawer() {
    this.drawer.setAttribute("aria-hidden", false);
    this.drawer.setAttribute("aria-expanded", true);

    this.pageOverlayElement.classList.add("is-visible");
    document.body.addEventListener("click", this.onBodyClick);
  }

  closeMenuDrawer() {
    this.drawer.setAttribute("aria-hidden", true);
    this.drawer.removeAttribute("aria-expanded", true);

    this.pageOverlayElement.classList.remove("is-visible");
    document.body.removeEventListener("click", this.onBodyClick);

    // Close out all levels
    setTimeout(() => {
      document
        .querySelectorAll(".menu-drawer__menu-level.active")
        .forEach((level) => {
          level.classList.remove("active");
        });
    }, 350);
  }

  // Header renders a v1 and a v2 drawer menu with the same data-menu ids,
  // so look up the level inside the menu that was clicked, not the whole document
  getMenuLevel(button) {
    const menu = button.dataset.menu;
    const scope =
      button.closest(".menu-drawer__menu-first-level") || document;

    return scope.querySelector(`div[data-menu="${menu}"]`);
  }

  handleMenuClick(event) {
    const menuLevel = this.getMenuLevel(event.currentTarget);

    menuLevel?.classList.add("active");
  }

  handleBackClick(event) {
    const menuLevel = this.getMenuLevel(event.currentTarget);

    menuLevel?.classList.remove("active");
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains("page-overlay")) {
      this.closeMenuDrawer();
      this.pageOverlayElement.classList.remove("is-visible");
    }
  }
};

customElements.define("menu-drawer", MenuDrawer);

var QuantityInput = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    if (this.input) {
      this.input.addEventListener("change", this.validateQty.bind(this));
      this.input.addEventListener("blur", this.validateQty.bind(this));
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    this.validateQty();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQty() {
    if (!this.input) return;
    const minAttr = this.input.getAttribute("min");
    const maxAttr = this.input.getAttribute("max");
    // Use Number.isFinite — `parseInt(...) || 1` treats min="0" as falsy and
    // incorrectly clamps cart/minicart quantity back to 1 (blocks remove via qty).
    const parsedMin = parseInt(minAttr, 10);
    const min = Number.isFinite(parsedMin) ? parsedMin : 1;
    const parsedMax = parseInt(maxAttr, 10);
    const max = Number.isFinite(parsedMax) ? parsedMax : Infinity;

    let value = parseInt(this.input.value, 10);
    if (Number.isNaN(value) || value < min) value = min;
    if (value > max) value = max;
    this.input.value = String(value);
  }
};

customElements.define("quantity-input", QuantityInput);

const productCardCarousels = document.querySelectorAll(".product-card-swiper");
productCardCarousels.forEach((carousel) => {
  if (carousel.swiper) return;

  const swiper = new Swiper(carousel, {
    slidesPerView: 1,
    pagination: {
      el: carousel.querySelector(".swiper-pagination"),
      clickable: true,
    },
    allowTouchMove: true,
    nested: true,
    navigation: {
      nextEl: carousel.querySelector(".swiper-button-next"),
      prevEl: carousel.querySelector(".swiper-button-prev"),
    },
    loop: false,
    observer: true,
    observeParents: true,
      on: {
        init() {
          if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === "function") {
            window.lazySizes.loader.checkElems();
          }
        },
        slideChange() {
          if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === "function") {
            window.lazySizes.loader.checkElems();
          }
        },
      },
  });
});

// Used by component-color-variant-selection.js (stroller PDP) to keep ?variant= in sync.
const VARIANT_URL_PARAMS_TO_KEEP = [
  'ranMID',
  'ranEAID',
  'ranSiteID',
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_campaign',
  'abralink',
  'view',
];

function updateProductVariantUrl(variantId) {
  if (!variantId || !window.location.pathname.includes('/products/')) return;

  const url = new URL(window.location.href);
  const newParams = new URLSearchParams();

  VARIANT_URL_PARAMS_TO_KEEP.forEach((param) => {
    if (url.searchParams.has(param)) {
      newParams.set(param, url.searchParams.get(param));
    }
  });

  newParams.set('variant', variantId);
  window.history.replaceState({}, '', `${url.pathname}?${newParams.toString()}`);
}

window.updateProductVariantUrl = updateProductVariantUrl;

var VariantSelects = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    // if(this.closest('.product-card')) return;
    this.dispatchEvent(new Event("change"));
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateActiveVariantText(event);

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateProductBar();
      this.updateCardPrice();
      this.updateB2BPricing();
    }

    if (this.currentVariant) {
      $("variant-radios").attr("data-selvariant", this.currentVariant.title);

      let selectedVariant = this.currentVariant.title;

      if(window.$sliderMainProduct && window.$sliderThumbProduct){
        window.$sliderMainProduct.slick("slickUnfilter");
        window.$sliderThumbProduct.slick("slickUnfilter");
  
        window.$sliderMainProduct.slick("slickFilter", function () {
          return $(this).find("img").attr("alt") === selectedVariant;
        });
  
        window.$sliderThumbProduct.slick("slickFilter", function () {
          return $(this).find("img").attr("alt") === selectedVariant;
        });

        window.$sliderMainProduct.slick("slickGoTo", 1);
        window.$sliderThumbProduct.slick("slickGoTo", 1);

        setTimeout(function () {
          window.$sliderMainProduct.slick("setPosition");
          window.$sliderThumbProduct.slick("setPosition");
        }, 300);
      }
      
      let image =
        document.querySelector(
          `#${this.dataset.sliderId}.slider-nav [data-media-id="${this.dataset.section}-${this.currentVariant.featured_media?.id}"]`
        ) ||
        document.querySelector(
          `#${this.dataset.sliderId}.slider-nav [data-media-id="${this.dataset.section}-${this.currentVariant.featured_image?.id}"]`
        );

      // console.log(image,this.currentVariant.featured_media?.id,`#${ this.dataset.sliderId }.slider-nav [data-media-id="${this.dataset.section}-${this.currentVariant.featured_media?.id}"]`)

      if (this.closest(".product-card")) {
        const productCard = this.closest(".product-card");
        productCard.setAttribute(
          "data-variant-id",
          this.currentVariant.id
        );
        
        productCard.dataset.selectedVariant = this.currentVariant.id;
        
        const productLinks = productCard.querySelectorAll('.product-card__link, .product-card__main-link');
        productLinks.forEach(link => {
          const baseUrl = link.dataset.baseUrl;
          if (baseUrl) {
            const url = new URL(baseUrl, window.location.origin);
            url.searchParams.set('variant', this.currentVariant.id);
            link.href = url.toString();
          }
        });

        const desktopImageSets = productCard.querySelectorAll('.product-card__desktop-image-set');
        if (desktopImageSets.length > 0) {
          desktopImageSets.forEach(imageSet => {
            const variantId = imageSet.dataset.variantId;
            if (variantId == this.currentVariant.id) {
              imageSet.style.display = '';
            } else {
              imageSet.style.display = 'none';
            }
          });
        }
      }

      if (image) {
        let index = image.dataset.imageIndex;

        if (
          $(`#${this.dataset.sliderId}.slider-nav`).hasClass(
            "slick-initialized"
          )
        ) {
          $(`#${this.dataset.sliderId}.slider-nav`)[0].slick.goTo(index);
        } else if (
          $(`#${this.dataset.sliderId}.slider-nav`).hasClass("swiper-wrapper")
        ) {
          const swiperEl = document
            .querySelector(`#${this.dataset.sliderId}.slider-nav`)
            .closest(".swiper").swiper;
          this.updateSliderImages(this.currentVariant.title);
          // swiperEl.updateSlides();
          // swiperEl.slideTo(0);
        } else {
          $(`#${this.dataset.sliderId}.slider-nav`).on(
            "init",
            function (slick) {
              setTimeout(() => {
                slick.currentTarget.slick.goTo(index);
              }, 1000);
            }
          );
        }
      }
      $(document)
        .find(".product__info-wrapper #attn-waitlist-trigger")
        .attr("data-variant-id", this.currentVariant.id);
      if (!this.currentVariant.available) {
        $(document)
          .find(".product__info-wrapper")
          .find(".form-submit-button-wrapper")
          .addClass("hide");
        $(document).find(".notify_me").removeClass("hide");
      } else {
        $(document).find(".notify_me").addClass("hide");
        if ($(document).find(".notify_me").hasClass("hide")) {
          $(document).find(".notify_me").addClass("hide");
        }
        if (
          $(document)
            .find(".product__info-wrapper")
            .find(".form-submit-button-wrapper")
            .hasClass("hide")
        ) {
          $(document)
            .find(".product__info-wrapper")
            .find(".form-submit-button-wrapper")
            .removeClass("hide");
        }
      }
    }
  }

  updateCardPrice(){
    let closestCard = this.closest(".product-card");
    if(closestCard){
      let cardPrice = closestCard.querySelector(".product-card__price");
      if(cardPrice){
        cardPrice.innerHTML = Shopify.formatMoney(this.currentVariant.price);
      }
    }
  }

  updateB2BPricing() {
    if (this.closest(".product-card")) return;
    if (!this.currentVariant) return;

    const msrpDataEl = this.querySelector(".variant-msrp-data");
    if (!msrpDataEl) return;

    try {
      const msrpData = JSON.parse(msrpDataEl.textContent);
      const variantData = msrpData[this.currentVariant.id];
      if (!variantData) return;

      const priceWrappers = document.querySelectorAll(
        ".product__price, .stroller-main-product__price"
      );
      if (!priceWrappers.length) return;

      priceWrappers.forEach((wrapper) => {
        const msrpPriceEl = wrapper.querySelector(".price__msrp-price");
        const msrpContainer = wrapper.querySelector(".price__msrp");
        if (msrpPriceEl) {
          if (variantData.msrp) {
            msrpPriceEl.textContent = variantData.msrp;
            if (msrpContainer) msrpContainer.style.display = "";
          } else if (msrpContainer) {
            msrpContainer.style.display = "none";
          }
        }

        const wholesalePriceEl = wrapper.querySelector(
          ".price__wholesale-price"
        );
        if (wholesalePriceEl) {
          wholesalePriceEl.textContent = this.formatB2BMoney(
            this.currentVariant.price
          );
        }

        const skuEl = wrapper.querySelector(".price__b2b-sku");
        if (skuEl) {
          if (variantData.sku) {
            skuEl.textContent = `SKU: ${variantData.sku}`;
            skuEl.style.display = "";
          } else {
            skuEl.style.display = "none";
          }
        }

        const upcEl = wrapper.querySelector(".price__b2b-upc");
        if (upcEl) {
          if (variantData.barcode) {
            upcEl.textContent = `UPC: ${variantData.barcode}`;
            upcEl.style.display = "";
          } else {
            upcEl.style.display = "none";
          }
        }
      });
    } catch (e) {
      // Silently fail; a full section re-render will recover correct state.
    }
  }

  formatB2BMoney(cents) {
    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      try {
        return Shopify.formatMoney(cents);
      } catch (e) {
        // fall through
      }
    }
    try {
      const locale = `${Shopify.locale}-${Shopify.country}`;
      const currency = Shopify.currency.active;
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(cents / 100);
    }
  }

  updateSliderImages(title) {
    const container = this.closest(".product-card");
    const slider = container?.querySelector(".slider-nav");
    const images = slider?.querySelectorAll(".swiper-slide");

    images?.forEach((img) => {
      if (img.dataset.slide == title) {
        img.classList.remove("hidden-slide");
      } else {
        img.classList.add("hidden-slide");
      }
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    const variantData = this.getVariantData();

    if (variantData) {
      this.currentVariant = variantData.find((variant) => {
        return !variant.options
          .map((option, index) => {
            if (typeof this.options !== "undefined") {
              return this.options[index] === option;
            }
          })
          .includes(false);
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader =
      this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent
        .querySelector("li.product__media-item")
        .scrollIntoView({ behavior: "smooth" });
    });
  }

  // updateURL() {
  //   if (
  //     !this.currentVariant ||
  //     this.dataset.updateUrl === "false" ||
  //     window.location.href.indexOf("ranMID") > -1
  //   )
  //     return;
  //   window.history.replaceState(
  //     {},
  //     "",
  //     `${this.dataset.url}?variant=${this.currentVariant.id}`
  //   );
  // }
  updateURL() { 
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return; 
  
    const url = new URL(window.location.href);
    // Extract important tracking parameters
    const paramsToKeep = ['ranMID', 'ranEAID', 'ranSiteID', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'abralink'];
    const newParams = new URLSearchParams();
    
    paramsToKeep.forEach(param => {
        if (url.searchParams.has(param)) {
            newParams.set(param, url.searchParams.get(param));
        }
    });
    // Preserve parameters and update only the variant ID
    newParams.set('variant', this.currentVariant.id);
    
    window.history.replaceState({}, '', `${url.pathname}?${newParams.toString()}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-installments`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    if ($("body").hasClass("template-page.explore-page")) {
      var varianttitle = this.currentVariant.title;

      $(".product__media-item").find(".product__media").addClass("hide");
      $(".product__media-item")
        .find('[data-title="' + varianttitle + '"]')
        .removeClass("hide");
    }

    let formattedPrice = Shopify.formatMoney(this.currentVariant.price);
    if ($("body").hasClass("template-page.explore-page")) {
      $(".price-item--regular").html(formattedPrice);
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {

        if (!document.body.classList.contains("abra--announced")) {
          let html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          let id = `price-${this.dataset.section}`;

          let destinations = document.querySelectorAll(".product__price");
          let source = html.getElementById(id);
          if (source && destinations) {
            destinations.forEach((destination) => {
              destination.innerHTML = source.innerHTML;
            });
          }
        }else{
          let html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          let id = `price-${this.dataset.section}`;

          let destinations = document.querySelectorAll(".product__price");
          let source = html.getElementById(id);
          if (source && destinations) {
            destinations.forEach((destination) => {
              destination.innerHTML = source.innerHTML;
            });
          }
        }

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  updateActiveVariantText(event) {
    const isColor = event.target.classList.contains(
      "product-form__color-swatch-input"
    );

    if (isColor) {
      let value = event.target.closest("input:checked").value;
      const activeTextEl = this.querySelector(".product-form__active-color p");
      if (activeTextEl) {
        activeTextEl.innerHTML = value;
      }
    }
  }

  updateProductBar() {
    const atcButton = document.querySelector(".product-bar__atc");
    if (atcButton) {
      atcButton.setAttribute("data-id", this.currentVariant.id);

      if (this.currentVariant.option1) {
        const pbOption1 = document.querySelector(".product-bar__variant--1");
        pbOption1.textContent = this.currentVariant.option1;
      }

      if (this.currentVariant.option2) {
        const pbOption2 = document.querySelector(".product-bar__variant--2");
        pbOption2.textContent = this.currentVariant.option2;
      }

      if (this.currentVariant.option3) {
        const pbOption3 = document.querySelector(".product-bar__variant--3");
        pbOption3.textContent = this.currentVariant.option3;
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let isPreorder;
    let useCustomATC;

    if (
      this.closest(".product-card") &&
      this.closest(".product-card").querySelector("quick-add")
    ) {
      if (this.querySelector(".Swatches_Box input:checked")) {
        isPreorder = this.querySelector(".Swatches_Box input:checked").dataset
          .preorder;
        useCustomATC = this.querySelector(".Swatches_Box input:checked").dataset
          .customatctext;
      } else {
        isPreorder = this.querySelector(
          ".product-form__dropdown-container input:checked"
        ).dataset.preorder;
        useCustomATC = this.querySelector(
          ".product-form__dropdown-container input:checked"
        ).dataset.customatctext;
      }

      const quickAddButtons =
        this.closest(".product-card").querySelectorAll("quick-add");
      quickAddButtons.forEach(function (element) {
        if (useCustomATC != "" && disable) {
          element.removeAttribute("disabled");
          element.querySelector("span").textContent = useCustomATC;
        } else if (disable) {
          element.setAttribute("disabled", "disabled");
          if (text) element.querySelector("span").textContent = text;
        } else if (isPreorder == "true") {
          element.removeAttribute("disabled");
          element.querySelector("span").textContent = "Pre-Order";
        } else {
          element.removeAttribute("disabled");
          element.querySelector("span").textContent =
            window.variantStrings.addToCart;
        }
      });
    }

    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (productForm.querySelector(".Swatches_Box input:checked")) {
      isPreorder = productForm.querySelector(".Swatches_Box input:checked")
        .dataset.preorder;
    } else {
      isPreorder = productForm.querySelector(
        ".product-form__dropdown-container input:checked"
      ).dataset.preorder;
    }
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else if (isPreorder == "true") {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = "Pre-Order";
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (button) {
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add("visibility-hidden");
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
};

customElements.define("variant-selects", VariantSelects);

var VariantRadios = class extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    if (fieldsets.length > 0) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
    }
  }
};

customElements.define("variant-radios", VariantRadios);

class collectionFilters extends HTMLElement {
  constructor() {
    super();

    this.grid = document.querySelector(".product-grid");
    this.form = document.querySelector(".filters-form");
    this.dropdownButtons = document.querySelectorAll(
      ".filter-bar__dropdown-button"
    );
    this.filterButtons = document.querySelectorAll(
      ".filter-bar__filter-button"
    );
    this.activeTagsContainer = this.querySelector(
      ".filter-bar__active-filters"
    );
    this.clearCategoryButtons = this.querySelectorAll(
      ".filter-bar__clear-dropdown"
    );
    this.clearAllFiltersButtons = this.querySelectorAll(
      ".js-clear-all-filters"
    );
    this.openMobileFilterButtons = document.querySelectorAll(
      ".js-open-mobile-filters"
    );
    this.closeMobileFilterButtons = document.querySelectorAll(
      ".js-close-mobile-filters"
    );

    this.setListeners();
  }

  setListeners() {
    // Handle Dropdown Click
    this.dropdownButtons.forEach((item) => {
      item.addEventListener("click", this.handleDropdownClick);
    });

    // Handle Filter Click
    [...this.querySelectorAll(".filter-bar__filter-button")].forEach((item) => {
      if (item.classList.contains("sort-by")) {
        item.addEventListener("click", this.handleSortClick.bind(this));
      } else {
        item.addEventListener("click", this.handleFilterClick.bind(this));
        item.parentElement.parentElement
          .querySelector(".filter-bar__dropdown-button")
          .classList.add(".has-active-filters");
      }
    });

    // Handle Remove Filter
    this.activeTagsContainer.addEventListener("click", (event) => {
      event.preventDefault();

      if (
        event.target.classList.contains("remove-filter") ||
        event.target.classList.contains("remove-filter-svg")
      ) {
        const filter = event.target.dataset.filter;
        const initial = event.target.dataset.url;
        const newUrl =
          window.location.protocol + "//" + window.location.host + initial;

        this.removeSelectedFilter(filter);
        this.reloadSections(newUrl);
      }
    });

    // Clear Category Filters
    this.clearCategoryButtons.forEach((button) => {
      button.addEventListener("click", this.clearCategoryFilters.bind(this));
    });

    // Clear All Filters
    this.clearAllFiltersButtons.forEach((button) => {
      button.addEventListener("click", this.clearAllFilters.bind(this));
    });

    // Mobile open
    this.openMobileFilterButtons.forEach((filter) => {
      filter.addEventListener("click", (event) => {
        event.preventDefault();
        const overlay = document.querySelector(".filters__mobile-overlay");

        document.querySelector(".filter-bar__left").classList.add("active");
        overlay.classList.add("active");
        overlay.addEventListener("click", (event) => {
          document
            .querySelector(".filter-bar__left")
            .classList.remove("active");
          overlay.classList.remove("active");
        });
      });
    });

    // Mobile close
    this.closeMobileFilterButtons.forEach((filter) => {
      filter.addEventListener("click", (event) => {
        event.preventDefault();

        document.querySelector(".filter-bar__left").classList.remove("active");
        document
          .querySelector(".filters__mobile-overlay")
          .classList.remove("active");
      });
    });
  }

  handleDropdownClick(event) {
    event.preventDefault();
    const dropdown = this.parentElement.querySelector(
      ".filter-bar__dropdown-container"
    );

    if (this.classList.contains("active")) {
      this.classList.remove("active");
      fadeOut(dropdown, 300);
    } else {
      this.classList.add("active");
      fadeIn(dropdown, 300);
    }
  }

  handleFilterClick() {
    this.closeAllDropdowns();
    this.reloadSections();
  }

  removeSelectedFilter(filter) {
    $(`.filter-bar__filter-button[name="${filter}"]:checked`).prop(
      "checked",
      false
    );
  }

  handleSortClick() {
    event.preventDefault();
    const sort = event.currentTarget.value;
    this.sortBy = sort;

    this.closeAllDropdowns();
    this.reloadSections();
  }

  closeAllDropdowns() {
    this.dropdownButtons.forEach((button) => {
      if (button.classList.contains("active")) {
        button.classList.remove("active");
        slideUp(button.nextElementSibling);
      }
    });
  }

  clearCategoryFilters() {
    event.preventDefault();
    event.currentTarget.parentElement
      .querySelector("input:checked")
      .removeAttribute("checked");

    this.closeAllDropdowns();
    this.reloadSections();
  }

  clearAllFilters() {
    event.preventDefault();

    [
      ...document.querySelectorAll(
        ".filter-bar__filters .filter-bar__filter-button"
      ),
    ].forEach((item) => {
      item.removeAttribute("checked");
    });

    this.closeAllDropdowns();
    this.reloadSections();

    document.querySelector(".filter-bar__left").classList.remove("active");
    document
      .querySelector(".filters__mobile-overlay")
      .classList.remove("active");
  }

  reloadSections() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();

    const url = location.pathname + "?" + searchParams;

    if (history.replaceState) {
      window.history.pushState({ path: url }, "", url);
    }

    // Fetch and replace sections
    this.enableLoading();
    fetch(location.pathname + "?" + searchParams)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        this.getSectionsToRender().forEach((section) => {
          document.getElementById(section.id).innerHTML = new DOMParser()
            .parseFromString(html, "text/html")
            .getElementById(section.id).innerHTML;
        });

        this.disableLoading();
      })
      .catch(() => {
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      { id: "product-grid" },
      { id: "active-filters" },
      { id: "product-results" },
      { id: "mobile-filter-count" },
      { id: "mobile-filter-dropdown-count" },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    this.grid.classList.add("loading");
  }

  disableLoading() {
    this.grid.classList.remove("loading");
  }
}

customElements.define("collection-filters", collectionFilters);

var VideoLightbox = class extends HTMLElement {
  constructor() {
    super();

    this.openButtons = this.querySelectorAll(".js-open-lightbox");
    this.lightbox = this.querySelector(".lightbox");
    this.overlay = this.querySelector(".lightbox__overlay");
    this.video = this.querySelector(".lightbox__video video");
    this.openButtons.forEach((item) =>
      item.addEventListener("click", this.openLightBox.bind(this))
    );
  }

  openLightBox() {
    event.preventDefault();

    this.lightbox.classList.add("is-open");
    if (this.video) {
      this.video.play();
    }

    this.overlay.addEventListener("click", this.closeLightBox.bind(this));
    document.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.closeLightBox()
    );
  }

  closeLightBox() {
    if (this.video) {
      this.video.pause();
    }
    this.lightbox.classList.remove("is-open");
  }
};

customElements.define("video-lightbox", VideoLightbox);

var QuickAdd = class extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", function () {
      this.addToCart();
    });
  }

  addToCart() {
    this.setAttribute("disabled", true);
    this.classList.add("loading");
    const productCard = this.closest(".product-card");
    const variant = parseInt(productCard.dataset.variantId);
    const freeGiftId = productCard.dataset.freeGift;
    const cartDrawer = document.querySelector("cart-drawer");

    const body = JSON.stringify({
      items: [{ id: variant, quantity: 1 }],
      sections: this.getSectionsToRender().map((section) => section.section),
    });

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    })
      .then((response) => response.json())
      .then((parsedState) => {
        const addedItem = parsedState.items ? parsedState.items[parsedState.items.length - 1] : parsedState;
        
        if (freeGiftId && freeGiftId !== '' && addedItem && addedItem.variant_id) {
          const freeGiftPayload = {
            id: freeGiftId,
            quantity: 1,
            properties: {
              _free_gift: 'true',
              _parent_variant_id: String(addedItem.variant_id)
            }
          };
          // Companion on Stoq preorder: attach its selling plan so the line
          // is added in its preorder state, not as a plain default variant,
          // plus the app's line properties (visible shipping text in cart).
          const gateCfg = window.preorderGateConfig;
          if (gateCfg && gateCfg.companionSellingPlanId &&
              String(gateCfg.companionVariantId) === String(freeGiftId)) {
            freeGiftPayload.selling_plan = gateCfg.companionSellingPlanId;
            Object.assign(freeGiftPayload.properties, getPreorderCompanionProperties(freeGiftId));
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(freeGiftPayload)
          })
          .then(res => res.json())
          .then(() => {
            return fetch(`${routes.cart_update_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                updates: {},
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              })
            }).then(response => response.json());
          });
        }
        return parsedState;
      })
      .then((parsedState) => {
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.classList.remove("loading");
        this.removeAttribute("disabled");
        cartDrawer.open();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer__content",
        section: document.getElementById("cart-drawer__content").dataset.id,
        selector: ".cart-drawer__content",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
};

customElements.define("quick-add", QuickAdd);
